import React from 'react'
import logo from '../../img/logo-meso-circle-bw.png';

export const MesoLogoCircleBW = (props) => {
  
    const className = props.className;

    return <img className={className} src={logo} alt="Mesothelioma UK Logo" />;
}

